import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { goHome } from 'modules/steps/actions';
import UserProfile from '../components/UserProfile';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.userProfile,
    color: state.app.color1,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    goHome: bindActionCreators(goHome, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserProfile),
);



// WEBPACK FOOTER //
// ./src/routes/UserProfile/container/index.js